import { Component } from '@angular/core';

@Component({
  templateUrl: './vip-settings-page.component.html',
})
/**
 * Vip Settings Page
 */
export class VipSettingsPage {}
